<template>
  <div>
    <v-simple-table
      dense
    >
    <template v-slot:default>
      <thead>
        <tr>
          <th style="text-align: left; font-weight: 900 !important; color: #000000 !important; font-size: 16px;" width="150">
            {{ $t("agenda.lblPermittedAttendee") }}
          </th>
          <th style="text-align: left; font-weight: 900 !important; color: #000000 !important; font-size: 16px;" width="120">
            {{ $t("agenda.lblAction") }}
          </th>
          <th style="text-align: left; font-weight: 900 !important; color: #000000 !important; font-size: 16px;">
            {{ $t("agenda.hMisc") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in results"
          :key="item.id"
          class="hover-white-bg avoid-page-break"
          >
          <td :style="section === 'pdf' ? 'padding-left: 0px;' : ''">
            <v-list flat class="pa-0 ma-0">
            <v-list-item class="pa-0 ma-0">
            <v-list-item-avatar class="list-avatar mb-0" size="30" v-if="section === 'pdf'">
              <img v-if="item.profilePhoto"  :src="item.profilePhoto" />
              <img v-else :src="noImage" />
            </v-list-item-avatar>
            <v-list-item-avatar class="list-avatar mb-0" size="30" v-else>
              <v-img v-if="item.profilePhoto" :src="item.profilePhoto"></v-img>
              <v-img v-else :src="noImage"></v-img>
            </v-list-item-avatar>

            <v-list-item-content :style="section === 'pdf' ? 'padding-left: 10px;' : ''">
              <v-list-item-title v-if="item.firstName">
                <strong> {{ item.firstName + " " + item.lastName }}</strong>
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.firstName">{{
                item.userEmail
              }}</v-list-item-subtitle>
              <v-list-item-title v-else>{{ item.userEmail }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          </td>
          <td>
            <span v-if="item.status === 'notacted'"><strong> {{ $t("agenda.lblNotActed") }}</strong></span>
            <strong v-else>{{ getActionLable(item.status) }}</strong>
          </td>
          <td class="pa-1" style="word-wrap:break-word; width: fit-content;">
            <div v-if="item.status !== 'notacted'">
              <div>
                <strong>{{ getVotingLable(item.status) }}:</strong> &nbsp; 
                <span v-if="item.status === 'hasObjection' || item.status === 'noObjection'">{{ item.consent_updated_at }}</span>
                <span v-else>{{ item.voting_updated_at }}</span>
              </div>
              <div style="word-wrap:break-word; width: fit-content; word-break:break-all;" v-if="item.comment">
                <strong>{{ $t("agenda.lblComment") }}:</strong> {{ item.comment }}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  </div>
</template>

<script>
import noImage from "@/assets/images/NoPhotoIcon.png";
export default {
  name: "itemApprovalResultSection",
  props: {
    results: Array,
    section: String
  },
  data() {
    return {
      noImage
    };
  },

  methods: {
    getActionLable(label) {
      switch (label) {
        case "approve":
          return this.$t("agenda.Approved");
        case "abstain":
          return this.$t("agenda.Abstained");
        case "reject":
          return this.$t("agenda.Rejected");
        case "hasObjection":
          return this.$t("agenda.btnHasObjection");
        case "noObjection":
          return this.$t("agenda.btnNoObjection");
        default:
          return "not found";
      }
    },
    getVotingLable(label) {
      switch (label) {
        case "approve":
          return this.$t("agenda.lblApprovedAt");
        case "abstain":
          return this.$t("agenda.lblAbstainedAt");
        case "reject":
          return this.$t("agenda.lblRejectedAt");
        case "hasObjection":
          return this.$t("agenda.lblObjectionRaisedAt");
        case "noObjection":
          return this.$t("agenda.lblNoObjectionAt");
        default:
          return "not found";
      }
    }
  },
};
</script>
<style scoped>
::v-deep .v-list-item__title {
  font-size: 15px !important;
}
.list-avatar {
  align-self: flex-start;
}
tr.hover-white-bg:hover { 
  background-color: rgb(254, 255, 254) !important
} 
.avoid-page-break {
  page-break-inside: avoid;
}
</style>